import { cn } from '@/lib/cn';

type TitleProps = {
  children: React.ReactNode;
  className?: string;
  id?: string;
};

export const Title = ({ children, className, id }: TitleProps) => {
  return (
    <h1 id={id} className={cn('text-content-title mb-2! text-lg text-[1.75rem] leading-tight font-bold!', className)}>
      {children}
    </h1>
  );
};
